<template>
  <div class="office-page">
    <div class="office-header">
      <!-- <div class="office-header__left">
        <img class="office-logo" :src="logoUrl" alt="KOMI" />
        <div class="office-brand">KOMI</div>
      </div>
      <div class="office-header__right">
        <a class="office-link" :href="privacyUrl" target="_blank" rel="noopener noreferrer">Privacy</a>
        <a class="office-link" :href="termsUrl" target="_blank" rel="noopener noreferrer">Terms</a>
        <a class="office-link" :href="contactUrl" target="_blank" rel="noopener noreferrer">Contact us</a>
      </div>
    -->
    </div>
    <div class="office-wrap">
      <img class="office-img" :src="image1Url" alt="图1" />
      <img class="office-img" :src="image2Url" alt="图2" />
    </div>
  </div>
</template>

<script>
const OSS_BASE_URL = "https://komi-pord.oss-eu-central-1.aliyuncs.com/vue/"

export default {
  name: 'OfficeIndex',
  data() {
    return {
      logoUrl: OSS_BASE_URL + "office/logo.png",
      image2Url: OSS_BASE_URL + "office/1.png",
      image1Url: OSS_BASE_URL + "office/2.png",
      privacyUrl: '#',
      termsUrl: '#',
      contactUrl: '#'
    }
  }
}
</script>

<style scoped>
.office-page {
  --header-height: 2px;
  min-height: 100vh;
  padding: 0;
  background: #0b0b0b;
  overflow-x: hidden;
}

.office-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: linear-gradient(180deg, rgba(5, 10, 30, 0.9), rgba(5, 10, 30, 0.35));
  backdrop-filter: blur(6px);
  z-index: 10;
}

.office-header__left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.office-logo {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.375rem;
  object-fit: cover;
  display: block;
  background: rgba(255, 255, 255, 0.08);
}

.office-brand {
  font-size: 1.375rem;
  letter-spacing: 0.5px;
  color: #fff;
  font-weight: 600;
}

.office-header__right {
  display: flex;
  align-items: center;
  gap: 1.125rem;
}

.office-link {
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.875rem;
  text-decoration: none;
}

.office-link:hover {
  color: #fff;
}

.office-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: var(--header-height);
  line-height: 0;
}

.office-img {
  width: 100%;
  display: block;
  flex: 0 0 auto;
  border-radius: 0;
  height: auto;
  box-shadow: none;
}

.office-img + .office-img {
  margin-top: 10px;
}
</style>
